export default class SenderDetailsValidator {
    constructor() {
        this.errors = [];
        this.translations = {
            text_message_sender_name: 'SETTING:ERRORS:SENDER_NAME'
        }
    }

    validate(senderDetails) {
        this.errors = [];

        if (senderDetails.text_message_sender_name && senderDetails.text_message_sender_name.length > 11) {
            this.errors.push(this.translations.text_message_sender_name);
        }

        return this.errors.length == 0;
    };
};
